import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export default class customConfigUseCase extends BaseUseCase {
    constructor(readConfigRepo) {
        super();
        this.readConfigRepo = readConfigRepo;
    }
    fetchResult() {
        return this.readConfigRepo.customConfig();
    }
}
